export function PolicyDocument({ body, title }: { body: string; title: string }) {
  const parsed = parseMarkdown(body)
  const blocks =
    parsed[0]?.type === "heading" && parsed[0].content.trim() === title.trim()
      ? parsed.slice(1)
      : parsed
  return (
    <article className="policy-document" aria-labelledby="policy-document-title">
      <h2 id="policy-document-title" className="policy-title">
        {title}
      </h2>
      {blocks.map((block) => {
        if (block.type === "heading") {
          return (
            <h3 className="policy-heading" key={block.key}>
              {block.content}
            </h3>
          )
        }
        if (block.type === "list") {
          return (
            <ul key={block.key}>
              {block.items.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
          )
        }
        return <p key={block.key}>{block.content}</p>
      })}
    </article>
  )
}

type Block =
  | { type: "heading"; content: string; key: string }
  | { type: "list"; items: string[]; key: string }
  | { type: "paragraph"; content: string; key: string }

function parseMarkdown(markdown: string): Block[] {
  const blocks: Block[] = []
  const lines = markdown.split(/\r?\n/)
  let paragraph: string[] = []
  let list: string[] = []

  function flushParagraph() {
    if (!paragraph.length) return
    const content = paragraph.join(" ").trim()
    if (content) blocks.push({ type: "paragraph", content, key: `p-${blocks.length}` })
    paragraph = []
  }

  function flushList() {
    if (!list.length) return
    blocks.push({ type: "list", items: list, key: `l-${blocks.length}` })
    list = []
  }

  for (const rawLine of lines) {
    const line = rawLine.trim()
    if (!line) {
      flushParagraph()
      flushList()
      continue
    }
    if (line.startsWith("#")) {
      flushParagraph()
      flushList()
      const content = line.replace(/^#+\s*/, "")
      if (content) blocks.push({ type: "heading", content, key: `h-${blocks.length}` })
      continue
    }
    if (/^[-*]\s+/.test(line)) {
      flushParagraph()
      list.push(line.replace(/^[-*]\s+/, ""))
      continue
    }
    flushList()
    paragraph.push(line)
  }
  flushParagraph()
  flushList()
  return blocks
}
